import Choices from 'choices.js';
import { Tooltip } from 'bootstrap';

export default function initChoices() {
  const choices = document.querySelectorAll('[data-choices]');

  choices.forEach((el) => {
    const elementIcon = el.dataset.choicesIcon || '';
    const elementSize = el.dataset.choicesSize || 'lg';
    const elementStyle = el.dataset.choicesStyle || 'normal';
    const elementMarkDirty = el.dataset.choicesMarkDirty || false;
    const elementOrientation = el.dataset.choicesOrientation || 'left';
    const elementSelectedIcon = el.dataset.choicesSelectedIcon || '';
    const elementPlaceholder = el.dataset.choicesPlaceholder || '';
    const elementOptions = el.dataset.choices ? JSON.parse(el.dataset.choices) : {};
    const elementParent = el.parentElement;

    const defaultOptions = {
      allowHTML: true,
      shouldSort: false,
      removeItemButton: true,
      placeholderValue: elementPlaceholder,
      classNames: {
        containerInner: `choices__inner choices__size-${elementSize} choices__style-${elementStyle} choices__mark-dirty-${elementMarkDirty} choices__orientation-${elementOrientation}`,
      },
      searchFields: ['label', 'value', 'customProperties'],
      // https://choices-js.github.io/Choices/#choices-single-custom-templates
      callbackOnCreateTemplates(strToEl) {
        const itemSelectText = this.config.itemSelectText;
        return {
          item(option, data) {
            let html = ``;
            let label = String(data.label);

            const { classNames, removeItemButton } = option;

            html += `<div class="${String(classNames.item)} ${String(data.highlighted ? classNames.highlightedState : classNames.itemSelectable)}" data-item data-id="${String(data.id)}" data-value="${String(data.value)}" ${String(data.active ? 'aria-selected="true"' : '')} ${String(
              data.disabled ? 'aria-disabled="true"' : ''
            )}>`;

            if (elementIcon) html += `<span class="text-muted ${elementIcon} me-2"></span>`;

            if (elementSelectedIcon) label = `<span class="d-block fs-5 fe fe-${elementSelectedIcon}"></span>`;

            html += `<span class="${String(data.placeholder ? classNames.placeholder : '')} text-center">${label}</span>`;

            if (removeItemButton && this._isSelectMultipleElement) html += `<button type="button" class="choices__button" data-button>Remove item</button>`;

            html += `</div>`;

            return strToEl(html);
          },
          choice({ classNames }, data) {
            let html = ``;

            html += `<div class="${String(classNames.item)} ${String(classNames.itemChoice)} ${String(data.disabled ? classNames.itemDisabled : classNames.itemSelectable)}" data-select-text="${String(itemSelectText)}" data-choice ${String(
              data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'
            )} data-id="${String(data.id)}" data-value="${String(data.value)}" ${String(data.groupId > 0 ? 'role="treeitem"' : 'role="option"')}>`;

            html += `<div class="${String(data.placeholder ? classNames.placeholder : '')}">${String(data.label)}</div>`;

            if (data.customProperties && data.customProperties.description) {
              html += `<sup class="text-muted">${String(data.customProperties.description)}</sup>`;
            }

            return strToEl(html);
          },
        };
      },
    };

    const options = {
      ...elementOptions,
      ...defaultOptions,
    };

    new Choices(el, options);

    el.addEventListener(
      'showDropdown',
      function () {
        if (elementParent.dataset && elementParent.dataset.bsToggle === 'tooltip') {
          const tooltip = Tooltip.getOrCreateInstance(elementParent);
          tooltip.hide();
        }
      },
      false
    );
  });
}
